import { Button, Tooltip, useRestoreFocusTarget } from "@fluentui/react-components";
import React, { useCallback } from "react";

import { OpsGenieIcon } from "Apps/OpsGenie/Components/OpsGenieIcon/OpsGenieIcon";
import { observer } from "mobx-react";
import { useEnvironment } from "Shared/Hooks";
import { useGlobalSetting } from "Store/GlobalSettingStore";
import { useOpsGenieButtonStyles } from "./OpsGenieButton.styles";

const OpsGenieButtonBase = ({ additionalAction }: { additionalAction?: () => void }) => {
    const { isPublic } = useEnvironment();
    const classNames = useOpsGenieButtonStyles();
    const opsGenieStore = useGlobalSetting("opsGenieApp");
    const restoreFocusTargetAttribute = useRestoreFocusTarget();

    const handleClick = useCallback(() => {
        if (additionalAction) {
            additionalAction();
        }
        opsGenieStore.setIsRightPanelOpen(true);
    }, [opsGenieStore, additionalAction]);

    if (!isPublic) {
        return null;
    }
    return (
        <Tooltip content="OpsGenie Copilot" relationship="label">
            <Button
                id="opsgenie-copilot-button"
                appearance="transparent"
                onClick={handleClick}
                aria-label="Open OpsGenie panel"
                className={classNames.root}
                {...restoreFocusTargetAttribute}
            >
                <OpsGenieIcon />
            </Button>
        </Tooltip>
    );
};

export const OpsGenieButton = observer(OpsGenieButtonBase);
